import HelpIcon from "@/assets/icons/help-icon.svg?react"

import { useI18n } from "@/shared/i18n"
import { cn } from "@/shared/lib/utils"

import { openTournamentNominationsPost } from "../openTournamentNominationsPost"

interface TournamentNominationsHelpButtonProps {
  className?: string
}

/** Compact (?) — opens the nominations Telegram post. */
export function TournamentNominationsHelpButton({
  className,
}: TournamentNominationsHelpButtonProps) {
  const { t } = useI18n()

  return (
    <button
      type="button"
      onClick={openTournamentNominationsPost}
      aria-label={t("tournamentRewards.checkNominations")}
      className={cn(
        "flex size-6 shrink-0 items-center justify-center transition-opacity active:opacity-80",
        className
      )}
    >
      <HelpIcon className="size-5" aria-hidden />
    </button>
  )
}
